import React from "react";

/**
 * EggmanLogo — bare logo image, no background container.
 * The PNG already has a transparent background, so it sits cleanly
 * on any surface (cream, white, or the dark-green footer).
 */
export function EggmanLogo({ className = "h-14" }) {
  return (
    <div className="flex items-center" data-testid="eggman-logo">
      <img
        src="/eggman-logo.png"
        alt="EGGMAN — Fresh Eggs, Better Nutrition, Trusted Quality"
        className={`${className} w-auto object-contain`}
      />
    </div>
  );
}
